export default __webpack_public_path__ + "static/media/mail.70d8482e.png";